/** Cross-sell conversion metrics — last 30 days attachment/booked rates. */
import { useEffect, useState } from "react";
import api from "@/lib/api";

export default function CrossSellAnalytics() {
  const [xs, setXs] = useState(null);

  useEffect(() => {
    api.get("/admin/cross-sell-analytics", { params: { days: 30 } })
      .then(({ data }) => setXs(data))
      .catch(() => {});
  }, []);

  if (!xs) return null;
  return (
    <div data-testid="cross-sell-analytics-card" className="bg-[#0d0d0d] border border-[#C5A059]/20 rounded-xl p-5">
      <div className="mb-4">
        <p className="text-xs uppercase tracking-[0.2em] text-[#C5A059]">Cross-sell conversion · last {xs.days} days</p>
        <p className="text-sm text-zinc-400 mt-1 max-w-2xl">
          Guests who ticked a service on the transfer form vs. those we successfully booked.
          Update the conversion status on each booking&apos;s detail modal to keep this widget accurate.
        </p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
        {xs.services.map((s) => (
          <div key={s.code} data-testid={`xs-conv-${s.code}`} className="rounded-xl border border-white/10 bg-zinc-950 p-4">
            <p className="text-[10px] uppercase tracking-[0.2em] text-zinc-500 truncate">{s.label}</p>
            <p className="mt-2 font-display text-3xl text-white font-light tabular-nums">{s.rate_pct}%</p>
            <p className="mt-1 text-[10px] uppercase tracking-widest text-zinc-500 tabular-nums">
              {s.booked} booked · {s.leads} lead{s.leads === 1 ? "" : "s"}
            </p>
            <div className="mt-3 h-1 rounded-full bg-white/5 overflow-hidden">
              <div className="h-full bg-[#C5A059] transition-all" style={{ width: `${Math.min(100, s.rate_pct)}%` }} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
